
  import { Component, Vue } from "vue-property-decorator";
  import Header from "@/components/Header.vue";

  @Component({
    components: {
      Header
    }, 
    metaInfo:{
      title: "Pau Roselló",
      htmlAttrs: {
        lang: 'en-US'
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Researcher, developer and artist between Barcelona and California (UCSB).' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
      ]
    }
  })

  export default class App extends Vue{

  };
